var log = console.log;
class Commons {
  localizeAnalyticsData(data) {
    // log(data);
    var newUsers = data[0];
    var promocodes = data[1];
    var localizedNewUsers = [];
    var localizedPromocodes = [];
    var formattedData = [];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    newUsers.forEach(timestamp => {
      //   log(timestamp);
      localizedNewUsers.push(new Date(timestamp));
    });
    promocodes.forEach(timestamp => {
      //   log(timestamp);
      localizedPromocodes.push(new Date(timestamp));
    });
    var localizedNewUsers = localizedNewUsers.sort((a, b) => {
      let first = new Date(a);
      let second = new Date(b);
      //   log(first.getTime() - second.getTime());
      return first.getTime() - second.getTime();
    });
    var localizedPromocodes = localizedPromocodes.sort((a, b) => {
      let first = new Date(a);
      let second = new Date(b);
      //   log(first.getTime() - second.getTime());
      return first.getTime() - second.getTime();
    });

    localizedNewUsers.forEach(item => {
      let date = `${item.getDate()} ${
        months[item.getMonth()]
      } ${item.getFullYear()}`;
      let existingDate = formattedData.find((item, index, arr) => {
        return item.date == date ? index : null;
      });
      //   log(existingDate);
      if (!existingDate) {
        formattedData.push({
          date: date,
          newusers: 1,
          promocodes: 0,
          timeInMs: new Date(date).getTime()
        });
      } else {
        existingDate.newusers += 1;
      }
    });
    localizedPromocodes.forEach(item => {
      let date = `${item.getDate()} ${
        months[item.getMonth()]
      } ${item.getFullYear()}`;
      let existingDate = formattedData.find((item, index, arr) => {
        return item.date == date ? index : null;
      });
      //   log(existingDate);
      if (!existingDate) {
        formattedData.push({
          date: date,
          newusers: 0,
          promocodes: 1,
          timeInMs: new Date(date).getTime()
        });
      } else {
        existingDate.promocodes += 1;
      }
    });
    formattedData.sort((a, b) => {
      return a.timeInMs - b.timeInMs;
    });

    return formattedData.reverse();
  }
}
export default Commons;
